import { gql } from "@apollo/client";

const CAMPAIGN_FIELDS = `
  id
  name
  domain
  status
  state
  data
  createdAt
  updatedAt
`;

const GET_SENDER_ADDRESSES = gql`
  query senderAddresses($domain: String!) {
    senderAddresses(domain: $domain) {
      email
      verified
      status
    }
  }
`;

const GET_CAMPAIGN = gql`
  query campaign($id: ID!) {
    campaign(id: $id) {
      ${CAMPAIGN_FIELDS}
    }
  }
`;

const GET_CAMPAIGNS = gql`
  query campaigns($input: CampaignsInput) {
    campaigns(input: $input) {
      total
      campaigns {
        ${CAMPAIGN_FIELDS}
      }
    }
  }
`;

// List view: every field except the freeform `data` bag, which carries the
// full HTML email body (~130KB per campaign) and made the list take 10s+.
const GET_CAMPAIGNS_LIGHT = gql`
  query campaignsLight($input: CampaignsInput) {
    campaigns(input: $input) {
      total
      campaigns {
        id
        name
        domain
        status
        state
        createdAt
        updatedAt
      }
    }
  }
`;

const CAMPAIGN_CONTACT_LIFECYCLE_FIELDS = `
  id
  campaignId
  contactId
  domain
  lifecycleState
  dryRun
  messageId
  sentAt
  failedAt
  queuedAt
  attemptCount
  updatedAt
  deliveredAt
  openedAt
  clickedAt
  bouncedAt
  complainedAt
  suppressed
  suppressionReason
`;

const GET_CAMPAIGN_CONTACT_LIFECYCLES = gql`
  query campaignContactLifecycles($input: CampaignContactLifecyclesInput!) {
    campaignContactLifecycles(input: $input) {
      total
      items {
        ${CAMPAIGN_CONTACT_LIFECYCLE_FIELDS}
      }
    }
  }
`;

export {
  CAMPAIGN_FIELDS,
  GET_CAMPAIGN,
  GET_CAMPAIGNS,
  GET_CAMPAIGNS_LIGHT,
  CAMPAIGN_CONTACT_LIFECYCLE_FIELDS,
  GET_CAMPAIGN_CONTACT_LIFECYCLES,
  GET_SENDER_ADDRESSES,
};
